import '.a{display:flex;}.ssr-plugin'
import '.af{gap:12px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.iy{height:60px;}.ssr-plugin'
import '.iz{padding:12px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import { ReactNode, useState } from 'react'
import { styled, type Style } from 'inlines'
import { Text } from '../../Text/index.js'
import { colors } from '../../../tokens/colors.js'
import { IconButton } from '../../IconButton/index.js'
import { Button } from '../../Button/index.js'
import { Loader } from '../../Loader/index.js'
import { Menu } from '../../Menu/index.js'
import { useToast } from '../../Toast/index.js'
import { Modal } from '../../Modal/index.js'
import {
  TranslationLangSelect,
  TranslationLangSelectProps,
} from '../TranslationLangSelect/index.js'

const Separator = styled('div', {
  height: 12,
  width: 1,
  backgroundColor: colors.neutral10,
})

type ClearAllFieldsModalProps = {
  setOpenClearAllModal: (open: boolean) => void
  lang?: string
  totalAmountFields?: number
  onClear?: () => void
}

const ClearAllFieldsModal = ({
  setOpenClearAllModal,
  lang = 'translated',
  totalAmountFields,
  onClear,
}: ClearAllFieldsModalProps) => {
  const toast = useToast()

  return (
    <Modal
      // open={true}
      // onOpenChange={() => {
      //   setOpenClearAllModal(false)
      // }}
      size="small"
    >
      <Modal.Header title={`Clear all ${lang} fields`} />
      <Modal.Body>
        <Text>
          All {lang} fields within this section will be cleared — including
          approved fields.
        </Text>
      </Modal.Body>
      {/* <Modal.Actions>
        <Button
          variant="border"
          onClick={() => setOpenClearAllModal(false)}
          key="Esc"
          keyHint="Esc"
        >
          Cancel
        </Button>
        <Button
          color="red"
          key="Enter"
          keyHint="Enter"
          onClick={() => {
            onClear()
            setOpenClearAllModal(false)
            toast(`Cleared ${totalAmountFields} ${lang} fields.`, {
              icon: 'circle-dotted',
            })
          }}
        >
          Clear all
        </Button>
      </Modal.Actions> */}
    </Modal>
  )
}

export type TranslationTopBarProps = {
  preview?: ReactNode
  style?: Style
  value: string
  onLangChange: (iso: string) => void
  onClose?: () => void
  onClearAll?: () => void
  languages: string[]
}

export const TranslationTopBar = ({
  style,
  languages,
  preview,
  value,
  onLangChange,
  onClose,
  onClearAll,
}: TranslationTopBarProps) => {
  const [showPreviewMode, setShowPreviewMode] = useState(true)
  const [openClearAllModal, setOpenClearAllModal] = useState(false)
  const [metrics, setMetrics] = useState<'approved' | 'filled'>('approved')

  const toast = useToast()

  // MAke dynamic
  const totalAmountFields = 4
  const filledFields = 2
  const approvedFields = 1
  const filledPercentage = (filledFields / totalAmountFields) * 100
  const approvedPercentage = (approvedFields / totalAmountFields) * 100

  return (
    <styled.div className="a af d ae iy iz h"
      style={{
        borderBottom: `1px solid ${colors.neutral20Adjusted}`,
        ...style,
      }}
    >
      <div className="a af d">
        {onClose && <IconButton icon="close" onClick={onClose} />}
        <Separator />
        {/* <IconButton
          icon="chevron-up"
          onClick={() =>
            previewIdx === previews.length - 1
              ? setPreviewIdx(0)
              : setPreviewIdx(previewIdx + 1)
          }
        />
        <IconButton
          icon="chevron-down"
          onClick={() =>
            previewIdx === 0
              ? setPreviewIdx(previews.length - 1)
              : setPreviewIdx(previewIdx - 1)
          }
        />
        <Text variant="display-medium">{previews[previewIdx]}</Text> */}
        {/* <Separator /> */}
        {preview && (
          <IconButton
            icon="show"
            onClick={() => setShowPreviewMode(!showPreviewMode)}
            toggled={showPreviewMode}
          />
        )}
        {/* <IconButton
          icon="link-on"
          onClick={() => {
            toast('Link copied to your clipboard', {
              description: previewUrl,
              icon: 'copy',
            })
            navigator.clipboard.writeText(previewUrl)
          }}
        /> */}
      </div>

      <div className="a af d">
        <Menu>
          <Menu.Trigger>
            <Button
              variant="ghost"
              onClick={() => {}}
              trailIcon="tiny-chevron-down"
            >
              Manage fields
            </Button>
          </Menu.Trigger>
          <Menu.Items>
            <Menu.Header>Mark all fields as...</Menu.Header>
            <Menu.Item
              leadIcon="circle-regular"
              onClick={() =>
                toast(`Unapproved ${totalAmountFields} fields.`, {
                  icon: 'circle-regular',
                })
              }
            >
              Unapproved
            </Menu.Item>
            <Menu.Item
              leadIcon="checkmark-filled"
              style={{
                '& svg': {
                  color: colors.green80,
                },
              }}
              onClick={() =>
                toast(`Approved ${totalAmountFields} fields.`, {
                  icon: 'checkmark-filled',
                  iconColor: 'green80',
                })
              }
            >
              Approved
            </Menu.Item>
            <Menu.Separator />
            <Menu.Item
              leadIcon="delete"
              color="red"
              onClick={() => setOpenClearAllModal(true)}
            >
              Clear all
            </Menu.Item>
          </Menu.Items>
        </Menu>

        {openClearAllModal && (
          <ClearAllFieldsModal
            setOpenClearAllModal={setOpenClearAllModal}
            totalAmountFields={totalAmountFields}
          />
        )}

        {/* <Button
          variant="ghost"
          onClick={() => {}}
          trailIcon="tiny-chevron-down"
        >
          Auto Translate
        </Button> */}
        <Separator />
        <Menu>
          <Menu.Trigger>
            <Button variant="ghost" onClick={() => {}}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {metrics === 'approved' ? (
                  <>
                    <Loader value={approvedPercentage} />
                    {approvedFields} of {totalAmountFields} approved
                  </>
                ) : (
                  <>
                    <Loader value={filledPercentage} />
                    {filledFields} of {totalAmountFields} filled
                  </>
                )}
              </div>
            </Button>
          </Menu.Trigger>
          <Menu.Items>
            <Menu.Header>Show metric...</Menu.Header>
            <Menu.Item
              leadIcon={metrics === 'approved' ? 'checkmark-normal' : null}
              onClick={() => setMetrics('approved')}
              style={{
                paddingLeft: metrics === 'approved' ? 'inherit' : '40px',
              }}
            >
              {approvedFields} of {totalAmountFields} approved
            </Menu.Item>
            <Menu.Item
              leadIcon={metrics === 'filled' ? 'checkmark-normal' : null}
              onClick={() => setMetrics('filled')}
              style={{ paddingLeft: metrics === 'filled' ? 'inherit' : '40px' }}
            >
              {filledFields} of {totalAmountFields} Filled
            </Menu.Item>
          </Menu.Items>
        </Menu>
        <TranslationLangSelect
          languages={languages}
          value={value}
          onChange={onLangChange}
        />
      </div>
    </styled.div>
  )
}
